var map = {
	"./agent_k_k.mp3": 3394,
	"./aloha_k_k.mp3": 228,
	"./animal_city.mp3": 1929,
	"./bubblegum_k_k.mp3": 6379,
	"./cafe_k_k.mp3": 5164,
	"./chillwave.mp3": 619,
	"./comrade_k_k.mp3": 5549,
	"./dj_k_k.mp3": 7973,
	"./drivin.mp3": 8378,
	"./farewell.mp3": 4006,
	"./forest_life.mp3": 4467,
	"./go_k_k_rider.mp3": 3115,
	"./hypno_k_k.mp3": 2656,
	"./i_love_you.mp3": 7497,
	"./imperial_k_k.mp3": 2664,
	"./k_k_adventure.mp3": 4846,
	"./k_k_aria.mp3": 3640,
	"./k_k_ballad.mp3": 1759,
	"./k_k_bashment.mp3": 9995,
	"./k_k_bazaar.mp3": 1581,
	"./k_k_birthday.mp3": 247,
	"./k_k_blues.mp3": 7587,
	"./k_k_bossa.mp3": 5373,
	"./k_k_break.mp3": 2298,
	"./k_k_calypso.mp3": 2548,
	"./k_k_casbah.mp3": 1357,
	"./k_k_chorale.mp3": 9873,
	"./k_k_chorinho.mp3": 2659,
	"./k_k_condor.mp3": 8581,
	"./k_k_country.mp3": 8955,
	"./k_k_cruisin.mp3": 6032,
	"./k_k_d_b.mp3": 2001,
	"./k_k_dirge.mp3": 9637,
	"./k_k_disco.mp3": 8750,
	"./k_k_dixie.mp3": 1887,
	"./k_k_dub.mp3": 5987,
	"./k_k_etude.mp3": 1879,
	"./k_k_faire.mp3": 6566,
	"./k_k_flamenco.mp3": 7822,
	"./k_k_folk.mp3": 5749,
	"./k_k_fugue.mp3": 6921,
	"./k_k_fusion.mp3": 5265,
	"./k_k_groove.mp3": 3765,
	"./k_k_gumbo.mp3": 8861,
	"./k_k_hop.mp3": 5330,
	"./k_k_house.mp3": 8928,
	"./k_k_island.mp3": 2874,
	"./k_k_jazz.mp3": 1794,
	"./k_k_jongara.mp3": 3373,
	"./k_k_khoomei.mp3": 3879,
	"./k_k_lament.mp3": 3609,
	"./k_k_love_song.mp3": 9441,
	"./k_k_lovers.mp3": 9410,
	"./k_k_lullaby.mp3": 6104,
	"./k_k_mambo.mp3": 7249,
	"./k_k_marathon.mp3": 4331,
	"./k_k_march.mp3": 9717,
	"./k_k_mariachi.mp3": 2318,
	"./k_k_metal.mp3": 9864,
	"./k_k_milonga.mp3": 8486,
	"./k_k_moody.mp3": 411,
	"./k_k_oasis.mp3": 3138,
	"./k_k_parade.mp3": 2578,
	"./k_k_polka.mp3": 5495,
	"./k_k_ragtime.mp3": 7952,
	"./k_k_rally.mp3": 3318,
	"./k_k_reggae.mp3": 9856,
	"./k_k_robot_synth.mp3": 8676,
	"./k_k_rock.mp3": 8521,
	"./k_k_rockabilly.mp3": 3704,
	"./k_k_safari.mp3": 1163,
	"./k_k_salsa.mp3": 2226,
	"./k_k_samba.mp3": 3329,
	"./k_k_ska.mp3": 4890,
	"./k_k_slack-key.mp3": 5793,
	"./k_k_sonata.mp3": 6676,
	"./k_k_song.mp3": 3629,
	"./k_k_soul.mp3": 9376,
	"./k_k_steppe.mp3": 6707,
	"./k_k_stroll.mp3": 141,
	"./k_k_swing.mp3": 8636,
	"./k_k_synth.mp3": 7869,
	"./k_k_tango.mp3": 3131,
	"./k_k_technopop.mp3": 2364,
	"./k_k_waltz.mp3": 1136,
	"./k_k_western.mp3": 7868,
	"./king_k_k.mp3": 2983,
	"./lucky_k_k.mp3": 7142,
	"./marine_song_2001.mp3": 7109,
	"./mountain_song.mp3": 7694,
	"./mr_k_k.mp3": 869,
	"./my_place.mp3": 5938,
	"./neapolitan.mp3": 2253,
	"./only_me.mp3": 3277,
	"./pondering.mp3": 5460,
	"./rockin_k_k.mp3": 4203,
	"./soulful_k_k.mp3": 8996,
	"./space_k_k.mp3": 5916,
	"./spring_blossoms.mp3": 8115,
	"./stale_cupcakes.mp3": 9853,
	"./steep_hill.mp3": 7294,
	"./surfin_k_k.mp3": 7812,
	"./the_k_funk.mp3": 6897,
	"./to_the_edge.mp3": 4577,
	"./two_days_ago.mp3": 9985,
	"./wandering.mp3": 4849,
	"./welcome_horizons.mp3": 8220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9991;